import React, { useEffect, useState, useContext, useRef } from 'react'; /*st48236 - 508 compliance*/
import { LanguageContext } from "../contexts/LanguageContext";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Glossary = () => {

    const { pageContent } = useContext(LanguageContext);
    const [glossaryContent, setGlossaryContent] = useState([]);
    const liveGlossaryRef = useRef(null); // Reference for the live region /*st48236 - 508 compliance*/
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
        const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed

    useEffect(() => {
        if (pageContent?.glossary) {
            setGlossaryContent(pageContent.glossary);
            setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
        }
    }, [pageContent]);

    /*st48236 - 508 compliance*/      
    // Mark content as ready
    const [userInteracted, setUserInteracted] = useState(false);
        
        useEffect(() => {
          const handleUserInteraction = () => {
            setUserInteracted(true);
          };
        
          // Listen for user interactions
          document.addEventListener('click', handleUserInteraction);
          document.addEventListener('keydown', handleUserInteraction);
          
          return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
          };
        }, []);
        
        useEffect(() => {
          let timeoutId;
          
          if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
              setContentReady(true);
              
              // Only auto-focus if user hasn't interacted
              if (!userInteracted && liveGlossaryRef.current) {
                requestAnimationFrame(() => {
                  liveGlossaryRef.current.focus({ preventScroll: true });
                });
              }
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
          }
          
          return () => {
            if (timeoutId) clearTimeout(timeoutId);
          };
        }, [apiCallsCompleted, isContentReady, userInteracted]);
    
    /*st48236 - 508 compliance*/
    return (
        <>
        <main
            role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={liveGlossaryRef} // Attach the ref to the <main> tag
            style={{ outline: 'none' }} // revmove border
            aria-label="Acronym and Description"
            className="glossary-content"
        > 
            <div className="conatiner-fluid content-inner mt-n5 py-0">
                <div className="card">
                    <div className="contactus px-3">
                        <div className="mt-2 mb-4 px-4">
                            <div className="col-12">
                                <section className="bg-white">
                                    <div tabIndex={0} className="container mt-4">
                                        {parse(DOMPurify.sanitize(glossaryContent?.glossary_content))}
                                    </div>
                                    <div tabIndex={0} className="content-gloss mt-s2 px-3 mt-5">
                                        {parse(DOMPurify.sanitize(glossaryContent?.glossary_main_content))}
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main> {/*st48236 - 508 compliance*/}
        </>
    )
}

export default Glossary;